import {Pipe, PipeTransform} from '@angular/core';
import {TtmTicketTypeOptions} from '../components/ttm-ticket-dialog/ttm-ticket-dialog.component';

@Pipe({
    name: 'TtmTicketType'
})
export class TtmTicketTypePipe implements PipeTransform {
    transform(value: string): string {
        return TtmTicketTypeOptions[value] || value;
    }
}
